export default __webpack_public_path__ + "static/media/logo.2664c0e2.png";